/* REFERRAL_PROMOTIONS — delete this file with the ReferralPromotions feature (see REMOVAL.md). */
import type { ReactNode } from 'react';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import ReferralPromotions, {
  fetchCampaignCms,
  isCampaignScreenTypeActive
} from '@cont/ReferralPromotions';

const BlankLayout = ({ children }: { children: ReactNode }) => children;

const SomethingNewIsComingPage = () => <ReferralPromotions />;

SomethingNewIsComingPage.pageInfo = {
  name: 'Something New Is Coming',
  isMWebSupported: true,
  layoutOptions: {
    hideHeader: true,
    hideFooter: true,
    hideIntercom: true,
    hideFreshbot: true,
    hideNudges: true,
    hideSalesBot: true
  }
};

SomethingNewIsComingPage.getInitialProps = async () => {
  try {
    const cms = await fetchCampaignCms();
    if (!isCampaignScreenTypeActive(cms.screenType)) {
      return { notFound: true };
    }
  } catch {
    return { notFound: true };
  }
  return {};
};

export default SomethingNewIsComingPage;

SomethingNewIsComingPage.Layout = BlankLayout;
SomethingNewIsComingPage.Wrapper = PageReduxProvider;
